import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  switch(event) {
    const select = event.currentTarget
    const switchees = document.querySelectorAll(`[id^="select-switchee-${select.name}"]`)
    switchees.forEach((element) => element.classList.add("hidden"))

    const switchee = document.getElementById(`select-switchee-${select.name}-${select.value}`)
    if (switchee) switchee.classList.remove("hidden")
  }
}
